import React from "react"

const CarInfo: React.FC = () => {
  return (
    <div
      id="car-info"
      className="bg-cream-50 rounded-3xl p-6 md:p-8 shadow-lg border border-sand-200"
    >
      <div className="mb-6">
        <h3 className="font-avenir text-2xl font-bold text-terracotta-800 mb-2 flex items-center justify-center">
          <span className="mr-2">🚗</span>
          Coche
        </h3>
        <p className="font-avenir text-sl text-gray-600 text-center leading-relaxed">
          Si optas por el coche particular, os dejamos estas notas importantes
          para facilitaros el día:
        </p>
      </div>

      <div className="space-y-6">
        <div className="bg-white rounded-2xl p-6 border border-sand-200">
          <div className="flex items-start space-x-4">
            <div className="bg-olive-100 rounded-full w-10 h-10 flex items-center justify-center mr-1 flex-shrink-0">
              <span className="text-lg">🅿️</span>
            </div>
            <div>
              <h4 className="font-avenir font-semibold text-base md:text-lg text-gray-800 leading-snug mb-2">
                En Morón de la Frontera (Para la Iglesia)
              </h4>
              <p className="font-avenir text-sm text-gray-600 leading-relaxed">
                Aparcar cerca de la iglesia puede ser complicado, por lo que os
                recomendamos dejar el coche directamente en el parking de la
                Plaza de Toros de Morón de la Frontera.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl p-6 border border-sand-200">
          <div className="flex items-start space-x-4">
            <div className="bg-olive-100 rounded-full w-10 h-10 flex items-center justify-center mr-1 flex-shrink-0">
              <span className="text-lg">🔑</span>
            </div>
            <div>
              <h4 className="font-avenir font-semibold text-base md:text-lg text-gray-800 leading-snug mb-2">
                En la Hacienda Saltillo-Lasso
              </h4>
              <p className="font-avenir text-sm text-gray-600 leading-relaxed">
                Podéis llegar en coche hasta el recinto de la celebración sin
                problema. Además, si al terminar la fiesta preferís volver en
                autobús o taxi, podéis dejar el coche aparcado en la Hacienda
                de forma totalmente segura y recogerlo al día siguiente.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CarInfo
